<div class="d-flex" #toolbarWrapper>
    @if (isSmallScreen) {
        <div class="dropdown-menu-container">
            <div ngbDropdown [autoClose]="isAutoClose" container="body" #dropdown="ngbDropdown">
                <div ngbDropdownToggle>
                    <ng-content select="[toggleControl]"></ng-content>
                </div>
                <div ngbDropdownMenu>
                    <div class="standard-dropdown-menu-close-button">
                        @if (!isAutoClose) {
                            <button class="navbar-toggler" type="button" aria-label="Close" (click)="dropdown.close()">
                                <i class="fas fa-window-close"></i>
                            </button>
                        }
                    </div>
                    <div class="standard-dropdown-menu-body">
                        <ng-container *ngTemplateOutlet="templateContent"></ng-container>
                    </div>
                </div>
            </div>
        </div>
    }
    @if (!isSmallScreen) {
        <div class="w-100">
            <ng-container *ngTemplateOutlet="templateContent"></ng-container>
        </div>
    }
    <ng-template #templateContent>
        <ng-content select="[toggleContent]"></ng-content>
    </ng-template>
</div>
